export interface MediaInfo {
  id?: string;
  name?: string;
  path?: string;
  uploadedDate?: string;
  size?: number;
  url?: string;
  fileType?: string;
}

export interface MediaInfoWithPreview extends MediaInfo {
  preview?: MediaInfo;
}

export interface VideoMediaInfo extends MediaInfo {
  duration?: number; // in milliseconds
  durationInMilliseconds?: number;
}

export interface AudioMediaInfo extends MediaInfo {
  duration?: number; // in milliseconds
  durationInMilliseconds?: number;
}

export interface ImageMediaInfo extends MediaInfo {
  width?: number;
  height?: number;
}

export const VIDEO_FILE_EXTENSIONS = ['.mp4', '.mov', '.wmv', '.avi', '.webm'];

export const AUDIO_FILE_EXTENSIONS = [
  '.mp3',
  '.m4a',
  '.wma',
  '.wav',
  '.flac',
  '.aac',
  '.ogg',
  '.aiff',
  '.alac',
];

export const IMAGE_FILE_EXTENSIONS = ['.jpeg', '.jpg', '.png', '.svg', '.heic'];

export const DOC_FILE_EXTENSIONS = ['.doc', '.docx'];
